export class Processes {
    id: string;
    name: string;
    status: string;
    actions: string;
    reasons: string;
    details: string;
    screens: string;
    available : string;
    sms_notify: string;
    escalations: string;
    email_notify: string;
    
    creation_user: string;
    creation_ip: string;
    created_at: string;

    last_update_user:string;
    last_update_ip:string;
    on_behalf_of:string;
    last_on_behalf_of:string;
    showDeletedOnly: boolean;

    constructor() {

    }
}



// WEBPACK FOOTER //
// ./src/app/views/management/processes/processes.ts